import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { guaranteeItems } from '../../data/landing';
import { CtaButton } from '../CtaButton';
export function Guarantee() {
  return <section className="w-full bg-canvas px-5 py-16 md:py-24" data-id="element-174" data-mp="24mommw1f3ih5">
      <div className="mx-auto max-w-4xl" data-id="element-175" data-mp="24ldkf0nmeis5">
        <div className="rounded-3xl bg-white p-6 ring-1 ring-navy/10 md:grid md:grid-cols-[220px_1fr] md:gap-10 md:p-10" data-id="element-176" data-mp="29e6m1fnslb00">
          <div className="flex flex-col items-center text-center" data-id="element-177" data-mp="2echy7x1k7xle">
            <div className="flex h-40 w-40 flex-col items-center justify-center rounded-full border-[6px] border-sky bg-navy text-white" data-id="element-178" data-mp="2jbl1bbxzbtqq">
              <ShieldCheckIcon className="h-9 w-9 text-sky-light" aria-hidden="true" data-id="element-179" data-mp="2obpearzoi6c7" />
              <span className="mt-1 font-serif text-4xl font-black leading-none" data-id="element-180" data-mp="2sbhplcggiql9">7-Day</span>
              <span className="mt-1 text-xs font-bold uppercase tracking-wider text-sky-light" data-id="element-181" data-mp="tyhndbetqevu">Guarantee</span>
            </div>
          </div>
          <div className="mt-8 md:mt-0" data-id="element-182" data-mp="y0l003d8bpip">
            <p className="text-sm font-extrabold uppercase tracking-wider text-sky" data-id="element-183" data-mp="3sloqljxoh2fe">My 7-day guarantee</p>
            <h2 className="mt-2 font-serif text-[30px] font-black leading-tight text-navy md:text-4xl" data-id="element-184" data-mp="3ntos7vx9ahkx">
              Try Ortho Treatment Map™ completely risk-free
            </h2>
            <p className="mt-4 text-[17px] leading-relaxed text-muted" data-id="element-185" data-mp="3dx27r88udsjf">
              I want you to be able to open the system, look through the volumes and actually use the treatment maps before deciding
              whether they’re right for you. So you have 7 days to:
            </p>
            <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-186" data-mp="5ggx7n0kare7">
              {guaranteeItems.map(item => <li key={item} className="flex items-start gap-2.5 font-medium text-navy" data-id="element-187" data-mp="i5ppixqosz5">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-188" data-mp="2q7hdvub5havd" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-5 text-[17px] leading-relaxed text-muted" data-id="element-189" data-mp="2la7pmhzhz594">
              If within those first 7 days you decide it isn’t useful for your practice, simply contact us and we’ll refund 100% of
              your purchase. <strong className="text-navy" data-id="element-190" data-mp="13ai4zos6ag3f">No complicated process. No interrogation. Just a simple guarantee.</strong>
            </p>
          </div>
        </div>

        <div className="mt-12" data-id="element-191" data-mp="18bfny3l0be5z">
          <CtaButton label="Try it risk-free for 7 days" data-id="element-192" data-mp="tkoukr3ro70r" />
        </div>
      </div>
    </section>;
}